export default class NumUtils {
    public static toStringFixedDig(num: number, dig: number) {
        return num.toLocaleString('en-GB', {
            minimumIntegerDigits: dig
        })
    }
}